import { faBars, faTableCellsLarge } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { twMerge } from 'tailwind-merge'
import { RaceView } from '../hooks/useRaceView'

const OPTIONS: Array<[RaceView, string, typeof faBars]> = [
    ['list', 'List view', faBars],
    ['grid', 'Grid view', faTableCellsLarge],
]

/**
 * Grid or list, for the race browser.
 *
 * Deliberately the same control, in the same two icons, as the Inventory page's — a player who has
 * learned it once should not have to learn it again on another page. It is purely cosmetic: both
 * views render the same races from the same query, so switching cannot change what you are
 * entered in or what you can win.
 *
 * Not shown on the Results tab, which is already a table and has nothing to toggle.
 */
export const RaceViewToggle = ({
    view,
    onChange,
    className,
}: {
    view: RaceView
    onChange: (view: RaceView) => void
    className?: string
}) => (
    <div className={twMerge('flex shrink-0 flex-row overflow-hidden border border-white/15', className)}>
        {OPTIONS.map(([value, label, icon]) => (
            <button
                key={value}
                onClick={() => onChange(value)}
                aria-pressed={view === value}
                title={label}
                aria-label={label}
                // 44px floor, the same tap target every other control on this page was measured
                // against.
                className={twMerge(
                    'flex min-h-[2.75rem] w-11 items-center justify-center transition-colors',
                    view === value ? 'bg-white/20 text-white' : 'text-white/45 hover:bg-white/10 hover:text-white/80'
                )}
            >
                <FontAwesomeIcon icon={icon} />
            </button>
        ))}
    </div>
)
